export default __webpack_public_path__ + "static/media/circle-empty.02dc89b8.svg";